export default {
    path: 'icon_manage',
    name: 'IconManage',
    component: () => import(/* webpackChunkName: "icon-manage" */ '@/pages/icon/IconManage.vue'),
    meta: { title: '图标管理' }
}
